import React from 'react'
import { Loader } from '../../../common/Loader'
import { Tabs } from '../../../common/Tabs'
import { CostItem, EstimatedFees, EstimatedProfit, SellingPrice } from '../components/CostItem'
import { LoaderContainer, TabsItemStyle, TabsListStyle } from '../styled'
import * as S from './styled'
import type { Props } from './types'

export const OnDemandPricing = ({ includeFeesValue, data }: Props) => {
  const renderTabs = () => {
    return (
      <Tabs>
        <S.TabsListContainer>
          <Tabs.List style={TabsListStyle}>
            {data?.map((tab) => (
              <Tabs.Item key={tab.label} style={TabsItemStyle} name={tab.label} variant="dimmed" />
            ))}
          </Tabs.List>
        </S.TabsListContainer>
        {data?.map((tab, index) => {
          return (
            <Tabs.Panel key={`${tab.price}-${index}`}>
              <SellingPrice value={tab.price} autoAdjusted={index !== 0} />
              <CostItem name="Manufacturing costs" value={tab.cost || 0} negative />
              {includeFeesValue && <EstimatedFees value={tab.feesValue} />}
              <EstimatedProfit value={tab.unitProfit} />
            </Tabs.Panel>
          )
        })}
      </Tabs>
    )
  }

  const renderContent = () => {
    if (!data.length) {
      return (
        <LoaderContainer>
          <Loader size="large" />
        </LoaderContainer>
      )
    }

    if (data.length > 1) {
      return renderTabs()
    }

    return (
      <>
        <CostItem name="Manufacturing costs" value={data[0].cost || 0} negative />
        {includeFeesValue && <EstimatedFees value={data[0].feesValue} />}
        <EstimatedProfit value={data[0].unitProfit} />
      </>
    )
  }

  return <div>{renderContent()}</div>
}
